import { ReactNode } from 'react';

/**
 * ContentHeader component for wrapping the content of the header (alerts and cover).
 */
function ContentHeader({ alerts, cover }: { alerts?: ReactNode; cover?: ReactNode }) {
  return (
    <div className="content-header">
      <div className="content-header-alerts">{alerts}</div>
      {cover && cover}
    </div>
  );
}

export default ContentHeader;
